export default __webpack_public_path__ + "static/media/neet_model_reg.2faeff2b.png";